import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { countryOptions } from '../../../portal/app/constants/countries';

const Country = ({ value }) => {
  const country = useMemo(() => (countryOptions || []).find(c => c.value === value)?.text, [value]);

  return <span>{country}</span>;
};

Country.propTypes = {
  value: PropTypes.string.isRequired,
};

export default Country;
